import { getRouteByIdentifier } from './get-route-by-identifier';
import { getRoutes } from './get-routes';
import { setAction } from './set-action';
/**
 * Registers an action for all routes.
 * @param actionFunction - Action to be registered.
 * @param options - Options for defining the actions.
 * @param options.baseRoute - .
 * @param options.except - Routes that will not receive the action.
 * @param options.includeSubroutesRecursively - include action in all component routes of the application routes or from a base route.
 */
export function setActionAll(actionFunction, options) {
    let routes = getRoutes();
    if (!routes || routes.length === 0) {
        return;
    }
    if (options === null || options === void 0 ? void 0 : options.baseRoute) {
        const baseRoute = getRouteByIdentifier(options.baseRoute);
        if (!(baseRoute === null || baseRoute === void 0 ? void 0 : baseRoute.children) || baseRoute.children.length === 0) {
            throw new Error('Base route has no subroutes.');
        }
        routes = baseRoute.children;
    }
    let routesToAddAction = routes;
    if (options === null || options === void 0 ? void 0 : options.includeSubroutesRecursively) {
        routesToAddAction = getRoutesWithoutChildren(routes);
    }
    routesToAddAction.forEach((route) => {
        var _a;
        const routeName = route.name;
        if (!routeName) {
            return;
        }
        if ((_a = options === null || options === void 0 ? void 0 : options.except) === null || _a === void 0 ? void 0 : _a.includes(routeName)) {
            return;
        }
        setAction(routeName, actionFunction);
    });
}
/**
 * Runs a Breadth-first search (BFS) and returns all routes without children routes.
 * @param routes Routes to be filtered.
 * @returns All routes without children.
 */
function getRoutesWithoutChildren(routes) {
    let routesQueue = routes;
    const routesWithoutChildren = [];
    while (routesQueue.length !== 0) {
        const currentRoute = routesQueue.shift();
        if (currentRoute.children) {
            routesQueue = routesQueue.concat(currentRoute.children);
        }
        else {
            routesWithoutChildren.push(currentRoute);
        }
    }
    return routesWithoutChildren;
}
